import React, { useEffect } from 'react';
import {
  ErrorLandingPageWrapper,
  HeaderMessage,
  ErrorMessage,
  Spacer,
} from './ErrorLandingPage.styles';
import OopsIcon from '../../assets/OopsIcon';
import { BridgecrestHyperLink } from '../bank-information/bridgecrest-information/BridgecrestInformation.styles';
import { useDualEventTracking } from '../../utils/useDualEventTracking';

function ErrorLandingPage() {
  const { trackEvent } = useDualEventTracking();
  useEffect(() => trackEvent('OopsError Screen'), []);

  return (
    <ErrorLandingPageWrapper>
      <OopsIcon />
      <HeaderMessage>Oops, something weird happened here.</HeaderMessage>
      <ErrorMessage>
        We got a little lost on our way to bringing you an amazing ownership
        experience.
        <br />
        Please try again later, or contact us at{' '}
        <BridgecrestHyperLink href="tel:8009678526" type="external">
          800-967-8526
        </BridgecrestHyperLink>{' '}
        or via chat in the lower right corner.
        <Spacer />
        Just so you know, you can also pay your loan directly at{' '}
        <BridgecrestHyperLink href="http://www.bridgecrest.com" target="_blank" type="external">
          Bridgecrest.com{' '}
        </BridgecrestHyperLink>{' '}
      </ErrorMessage>
    </ErrorLandingPageWrapper>
  );
}

export default ErrorLandingPage;
